var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", justify: "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivRT" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          return _vm.cerrarOperacion()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s("Ver Detalle Importar"))
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c(
                "div",
                [
                  _c(
                    "v-card",
                    { attrs: { height: "55px", flat: "" } },
                    [
                      _c(
                        "v-bottom-nav",
                        {
                          attrs: {
                            active: _vm.bottomNav,
                            value: true,
                            absolute: "",
                            color: "transparent"
                          },
                          on: {
                            "update:active": function($event) {
                              _vm.bottomNav = $event
                            }
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.informacionGeneral.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.informacionGeneralVerDetalle.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (informacionGeneral.visible && esEdicion) ||\n                  (informacionGeneralVerDetalle.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.informacionGeneral.step
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cierraMenu()
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v("Información General")]),
                              _c("v-icon", [_vm._v("info")])
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    (_vm.detalleCarga.visible &&
                                      _vm.esEdicion) ||
                                    (_vm.detalleCarga.visible &&
                                      !_vm.esEdicion),
                                  expression:
                                    "\n                (detalleCarga.visible && esEdicion) ||\n                  (detalleCarga.visible && !esEdicion)\n              "
                                }
                              ],
                              attrs: {
                                color: "primary",
                                flat: "",
                                value: _vm.detalleCarga.step
                              },
                              on: { click: _vm.cierraMenu }
                            },
                            [
                              _c("span", [_vm._v("Detalle Carga")]),
                              _c("v-icon", [_vm._v("credit_card")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.informacionGeneral.step &&
                            ((_vm.informacionGeneral.visible &&
                              _vm.esEdicion) ||
                              (_vm.informacionGeneralVerDetalle.visible &&
                                !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == informacionGeneral.step &&\n              ((informacionGeneral.visible && esEdicion) ||\n                (informacionGeneralVerDetalle.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "col-md-12",
                                  attrs: { "lazy-validation": "" },
                                  model: {
                                    value: _vm.validForm,
                                    callback: function($$v) {
                                      _vm.validForm = $$v
                                    },
                                    expression: "validForm"
                                  }
                                },
                                [
                                  _c(
                                    "v-container",
                                    { attrs: { "grid-list-md": "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "h2",
                                            {
                                              staticClass: "h2_title",
                                              staticStyle: {
                                                "margin-top": "12px!important",
                                                "font-weight": "normal"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      Información General\n                    "
                                              )
                                            ]
                                          ),
                                          _c("v-divider")
                                        ],
                                        1
                                      ),
                                      _c("br"),
                                      _c(
                                        "v-layout",
                                        { attrs: { wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md6: "" } },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Tipo Carga",
                                                  icon: "fas fa-angle-down",
                                                  "error-messages": _vm.errors.collect(
                                                    "tipoCarga"
                                                  ),
                                                  "data-vv-name": "tipoCarga",
                                                  "no-data-text":
                                                    "Sin resultados",
                                                  disabled: ""
                                                },
                                                model: {
                                                  value: _vm.editedItem.modulo,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "modulo",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.modulo"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              staticStyle: {
                                                "padding-top": "24px",
                                                "padding-right": "20px"
                                              },
                                              attrs: { md1: "" }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    text: "",
                                                    icon: "",
                                                    color: "white"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        title:
                                                          "Descargar Formato"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.descargaFormato()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        "assignment_returned"
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                directives: [
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "max:200|required",
                                                    expression:
                                                      "'max:200|required'"
                                                  }
                                                ],
                                                attrs: {
                                                  label: "Descripción",
                                                  counter: 200,
                                                  "data-vv-name": "descripcion",
                                                  type: "text",
                                                  "error-messages": _vm.errors.collect(
                                                    "descripcion"
                                                  ),
                                                  disabled: "",
                                                  required: ""
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.descripcion,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "descripcion",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.descripcion"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs12: "",
                                                sm12: "",
                                                md12: ""
                                              }
                                            },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  label: "Seleccionar Archivo",
                                                  heigh: "",
                                                  "prepend-icon": "attach_file",
                                                  readonly: "readonly",
                                                  disabled: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.$refs.image.click()
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.archivoRef,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "archivoRef",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.archivoRef"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.bottomNav == _vm.detalleCarga.step &&
                            ((_vm.detalleCarga.visible && _vm.esEdicion) ||
                              (_vm.detalleCarga.visible && !_vm.esEdicion)),
                          expression:
                            "\n            bottomNav == detalleCarga.step &&\n              ((detalleCarga.visible && esEdicion) ||\n                (detalleCarga.visible && !esEdicion))\n          "
                        }
                      ],
                      staticClass: "cardnew",
                      attrs: { align: "center" }
                    },
                    [
                      _c("br"),
                      _c("br"),
                      _c(
                        "v-flex",
                        { attrs: { md10: "" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "rounded-card" },
                            [
                              _c(
                                "v-container",
                                { attrs: { "grid-list-md": "" } },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "div",
                                        { attrs: { align: "left" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "h2",
                                                { staticClass: "h2_title" },
                                                [_vm._v("Detalle Carga")]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _c("v-divider"),
                                  _c("br"),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md3: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Fecha Carga",
                                              "persistent-hint": "",
                                              "prepend-inner-icon": "event",
                                              readonly: "",
                                              required: "",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.fechaCreacionTxt,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "fechaCreacionTxt",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.fechaCreacionTxt"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        { attrs: { md6: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Estado",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem
                                                  .estadoImportarTxt,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "estadoImportarTxt",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.estadoImportarTxt"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-layout",
                                    [
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs3: "", sm3: "", md3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Total Registros",
                                              disabled: "",
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.registrosNum,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "registrosNum",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.registrosNum"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs3: "", sm3: "", md3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Total OK",
                                              disabled: "",
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.editedItem.registrosOk,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "registrosOk",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.registrosOk"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-flex",
                                        {
                                          attrs: { xs3: "", sm3: "", md3: "" }
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Total Error",
                                              disabled: "",
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.editedItem.registrosError,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "registrosError",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.registrosError"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-layout",
                                    { attrs: { row: "", wrap: "" } },
                                    [
                                      _c(
                                        "v-flex",
                                        { attrs: { md6: "" } },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              "append-icon": "search",
                                              "prepend-icon": "lock_open",
                                              label: "Buscar..."
                                            },
                                            on: {
                                              input: _vm.onFilterTextBoxChanged
                                            },
                                            model: {
                                              value: _vm.buscar,
                                              callback: function($$v) {
                                                _vm.buscar = $$v
                                              },
                                              expression: "buscar"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c("v-flex", { attrs: { md6: "" } }, [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "padding-top": "15px"
                                            },
                                            attrs: { align: "right" }
                                          },
                                          [
                                            _vm.exportarVerDetalle.visible
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    staticStyle: {
                                                      "padding-right": "20px"
                                                    },
                                                    attrs: {
                                                      flat: "",
                                                      small: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.exportar()
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass:
                                                          "importExportBtnIcon"
                                                      },
                                                      [_vm._v("cloud_download")]
                                                    ),
                                                    _vm._v(
                                                      "  \n                        "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "importExportBtnTexto"
                                                      },
                                                      [_vm._v("Exportar")]
                                                    )
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { attrs: { align: "left" } },
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { md12: "" } },
                                            [
                                              _c(
                                                "v-card",
                                                [
                                                  _c("ag-grid-vue", {
                                                    key: _vm.dKey,
                                                    staticClass:
                                                      "ag-theme-material",
                                                    staticStyle: {
                                                      width: "100%",
                                                      height: "380px",
                                                      "font-family":
                                                        "'Asap', sans-serif"
                                                    },
                                                    attrs: {
                                                      columnDefs:
                                                        _vm.columnDefs,
                                                      rowData:
                                                        _vm.detalleRespaldo,
                                                      rowSelection: "single",
                                                      rowMultiSelectWithClick:
                                                        "false",
                                                      pagination: "true",
                                                      paginationPageSize: "10",
                                                      suppressRowClickSelection:
                                                        "true",
                                                      sideBar: _vm.sideBar,
                                                      localeText:
                                                        _vm.localeText,
                                                      onGridReady:
                                                        _vm.onGridReady,
                                                      postProcessPopup:
                                                        _vm.onClickCell,
                                                      suppressCopyRowsToClipboard:
                                                        "true",
                                                      suppressCsvExport: true,
                                                      suppressExcelExport: true,
                                                      processCellForClipboard:
                                                        _vm.processCellForClipboard
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Importar",
            nombreEntidad: _vm.editedItem.nombre
          }),
          mensaje: _vm.$t("mensajes.crud.editar.mensaje", {
            entidad: "Importar"
          }),
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar"),
          width: 450
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }